import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Icon from '../shared/Icon';
import './SideNav.css';

const COACH_NAV = [
  { to: '/app/dashboard',   iconName: 'dashboard', label: 'Dashboard' },
  { to: '/app/workout/new', iconName: 'plus',      label: 'New Workout' },
  { to: '/app/schedule',    iconName: 'schedule',  label: 'Schedule' },
  { to: '/app/feed',        iconName: 'feed',      label: 'Team Feed' },
  { to: '/app/profile',     iconName: 'profile',   label: 'Profile' },
];

const ATHLETE_NAV = [
  { to: '/app/dashboard', iconName: 'dashboard', label: 'Dashboard' },
  { to: '/app/schedule',  iconName: 'schedule',  label: 'My Schedule' },
  { to: '/app/feed',      iconName: 'feed',      label: 'Feed' },
  { to: '/app/profile',   iconName: 'profile',   label: 'Profile' },
];

export default function SideNav({ open, onClose }) {
  const { user, role, logout } = useAuth();
  const navigate = useNavigate();
  const navItems = role === 'coach' ? COACH_NAV : ATHLETE_NAV;

  function handleLogout() {
    logout();
    onClose();
    navigate('/');
  }

  return (
    <>
      {open && (
        <div className="sidenav-backdrop" onClick={onClose} aria-hidden="true" />
      )}
      <nav
        className={`sidenav ${open ? 'sidenav--open' : ''}`}
        aria-label="Main navigation"
        aria-hidden={!open}
      >
        <div className="sidenav__header">
          <span className="sidenav__logo">fitndex</span>
          <button className="sidenav__close" onClick={onClose} aria-label="Close navigation"><Icon name="close" size={16} /></button>
        </div>

        <div className="sidenav__user">
          <div className="sidenav__user-avatar">
            {user?.name?.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2)}
          </div>
          <div className="sidenav__user-info">
            <span className="sidenav__user-name">{user?.name}</span>
            <span className="sidenav__user-role">{role?.charAt(0).toUpperCase() + role?.slice(1)}</span>
          </div>
        </div>

        <ul className="sidenav__list">
          {navItems.map(({ to, iconName, label }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) =>
                  `sidenav__item ${isActive ? 'sidenav__item--active' : ''}`
                }
                onClick={onClose}
              >
                <span className="sidenav__item-icon"><Icon name={iconName} size={18} /></span>
                <span className="sidenav__item-label">{label}</span>
                {role === 'coach' && to === '/app/dashboard' && (
                  <span className="sidenav__badge">5</span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="sidenav__footer">
          <button className="sidenav__logout" onClick={handleLogout}>
            <Icon name="logout" size={16} /> Sign Out
          </button>
        </div>
      </nav>
    </>
  );
}
